
import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import { fetchAPI } from "@/utility/NetworkUtils";
import {
  Button,
} from "@mui/material"
import Modal from "react-modal";
import ReceivingListForm from "./ReceivingListForm";
const ReceivingListModal = ({
  closeModal,
  open,
  item,
  receivingItemId,
  user,
  deleteItem
}) => {
  const [ loading, setLoading ] = useState(true);
  const [ recievingItem, setRecievingItem ] = useState(null);
  const [ events, setEvents ] = useState([]);
  useEffect(() => {
    if(open) {
      setLoading(true)
      if(receivingItemId) {
        fetchAPI(`/webapi/receiving_items/${receivingItemId}`, (json)=> {
          if (!json.errors) {
            setRecievingItem(json.receiving_item)
          } else {
            console.log({
              errors: json.errors
            })
          }
          setLoading(false)
        }, {});
      }else {
        setLoading(false)
      }
    }else {
      setRecievingItem(null)
    }
  }, [open, receivingItemId])

  useEffect(() => {
    fetchAPI(`/webapi/events`, (json)=> {
      if (!json.errors) {
        setEvents(json.events)
      } else {
        console.log({
          errors: json.errors
        })
      }
      setLoading(false)
    }, {});
  }, [])



  return (
    <Modal
      className="react-modal inventory-modal add-form-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={closeModal}
    >
      {loading ? (
        <h1>
          Loading
        </h1>
      ): (
        <>
          <ReceivingListForm
            user={user}
            item={item}
            events={events}
            recievingItem={recievingItem}
            onCancel={closeModal}
            onSubmit={closeModal}
            deleteItem={deleteItem}
          /> 
        </>
      )}
 
    </Modal>
  )
}

export default ReceivingListModal